module.exports = __webpack_public_path__ + "img/815-1ed70b.png";